(() => {
  'use strict';
  const start = Date.parse('2026-10-22T22:00:00Z');
  const end = Date.parse('2026-10-24T22:00:00Z');
  const first = document.querySelector('[data-qt-flash]');
  if (!first) return;
  const preview = first.hasAttribute('data-qt-flash-preview');
  const anchor = performance.now();
  const server = Number(first.dataset.qtFlashNow) * 1000;
  const initial = preview ? start + 12 * 3600000 : server;
  const clock = () => initial + performance.now() - anchor;
  const dayMs = 24 * 3600000;
  function dayWindow(now) {
    const dayStart = start + Math.max(0, Math.floor((now - start) / dayMs)) * dayMs;
    const date = new Date(dayStart + dayMs / 2).toISOString().slice(0, 10).replaceAll('-', '');
    return {
      end: Math.min(end, dayStart + dayMs),
      key: 'qt-flash-header-' + date + '-' + (preview ? 'preview' : 'live')
    };
  }
  let day = dayWindow(clock());
  function readDismissed() {
    for (const name of ['localStorage', 'sessionStorage']) {
      try {
        const storage = window[name];
        const value = storage.getItem(day.key);
        if (value === '1' || Number(value) === day.end) {
          if (clock() < day.end) return true;
          storage.removeItem(day.key);
        }
      } catch {}
    }
    return false;
  }
  let dismissed = document.documentElement.dataset.qtFlashHeaderDismissed === 'true' || readDismissed();
  let refreshed = false;
  function sync() {
    const now = clock();
    const nextDay = dayWindow(now);
    if (nextDay.key !== day.key) {
      day = nextDay;
      dismissed = readDismissed();
    }
    const active = now >= start && now < end;
    const seconds = Math.max(0, Math.floor((day.end - now) / 1000));
    const time = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(n => String(n).padStart(2, '0')).join(':');
    if (dismissed) document.documentElement.dataset.qtFlashHeaderDismissed = 'true';
    else delete document.documentElement.dataset.qtFlashHeaderDismissed;
    document.querySelectorAll('[data-qt-flash]').forEach(node => {
      node.hidden = !active || (dismissed && node.dataset.qtFlashPlacement === 'header');
      const value = node.querySelector('[data-qt-flash-time]');
      if (value && value.textContent !== time) value.textContent = time;
      node.querySelectorAll('[data-qt-flash-close]').forEach(button => {
        if (button.dataset.qtFlashBound) return;
        button.dataset.qtFlashBound = 'true';
        button.addEventListener('click', () => {
          dismissed = true;
          for (const name of ['localStorage', 'sessionStorage']) {
            try { window[name].setItem(day.key, String(day.end)); } catch {}
          }
          sync();
        });
      });
    });
    document.querySelectorAll('[data-qt-flash-offer-time]').forEach(value => {
      if (value.textContent !== time) value.textContent = time;
    });
    if (!active && !preview) {
      document.querySelectorAll('.qt-flash-price__label, [data-qt-flash-offer-note]').forEach(node => { node.hidden = true; });
      document.documentElement.dataset.qtFlashEnded = 'true';
      if (!refreshed && now >= end) {
        refreshed = true;
        setTimeout(() => window.location.reload(), 1000);
      }
      return false;
    }
    return true;
  }
  sync();
  const interval = setInterval(() => { if (!sync()) clearInterval(interval); }, 1000);
  document.addEventListener('visibilitychange', sync);
  document.addEventListener('shopify:section:load', sync);
  window.addEventListener('pageshow', () => {
    dismissed = readDismissed() || dismissed;
    sync();
  });
  const observer = new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-qt-flash]') || node.querySelector('[data-qt-flash]'))))) sync();
  });
  observer.observe(document.body, {childList:true,subtree:true});
})();
